import { Stack, Typography } from "@mui/material";

const userGuideVideo = require("../../assets/videos/user-guide.mp4");
const thumbnail = require("../../assets/videos/thumbnail.png");

const Home = () => {
  return (
    <Stack maxWidth="720px" py="2.625rem" gap="2rem">
      <Stack gap={1}>
        <Typography
          variant="display4"
          lineHeight={{
            xl: "2.625rem",
            lg: "2.5rem",
          }}
          textAlign="left"
        >
          Welcome to the NGDI Dashboard
        </Typography>
        <Typography variant="subtitle1" textAlign="left" color="secondary">
          This platform provides a suite of tools designed to enhance your
          technical expertise in drought indices while fostering a deeper
          understanding of their dynamics. Here, you are the architect of your
          own drought indices: you are able to access a range of
          satellite-derived climate variables, visualize their performance, and
          develop more advanced, tailored disaster risk financing products to
          meet your objectives.
        </Typography>
        <Typography variant="subtitle1" textAlign="left" color="secondary">
          Originally developed for the Horn of Africa, the platform has now
          expanded to offer global coverage, opening the door to drought index
          exploration and design in any region of interest. The NGDI Dashboard
          provides the transparency, flexibility, and analytical control needed
          for the next generation of drought index development.
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center">
        <video
          preload="metadata"
          controls
          poster={thumbnail}
          width="632px"
          height="auto"
        >
          <source src={userGuideVideo} type="video/mp4" />
        </video>
      </Stack>
      <Stack gap={1} pb="2.625rem">
        <Typography variant="h5" color="#2D3648" fontWeight={500}>
          Disclaimer
        </Typography>
        <Typography variant="subtitle1" textAlign="left" color="secondary">
          The Next Generation Drought Index Dashboard ("the tool") is a capacity
          building tool. It has been developed by the World Bank to amplify your
          technical expertise in drought indices while fostering a deeper
          understanding of their dynamics. The tool is provided for
          informational purposes only and does not constitute legal or
          scientific advice or service. The World Bank makes no warranties or
          representations, express or implied as to the accuracy or reliability
          of the tool or the data contained therein. A user of the tool should
          seek qualified expert advice for specific diagnosis and analysis of a
          particular project. Any use thereof or reliance thereon is at the sole
          and independent discretion and responsibility of the user. No
          conclusions or inferences drawn from the tool should be attributed to
          the World Bank, its Board of Executive Directors, its Management, or
          any of its member countries. This tool does not imply any judgment or
          endorsement on the part the World Bank. In no event will the World
          Bank be liable for any form of damage arising from the application or
          misapplication of the tool, or any associated materials.
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Home;
